export default {
  common: {
    locale: 'en-GB',
    localeShort: 'en',
    company: 'Company',
    companies: 'Companies',
    authorized: 'Authorized',
    team: 'Team',
    teams: 'Teams',
    budget: 'Budget',
    budgetTooltip:
      'The budget is an <strong>identifier of a group of contractors linked by a single contract - not an amount of money</strong>. It indicates which client and which company the campaign belongs to.',
    client: 'Contractor',
    clients: 'Contractors',
    profile: 'Profile',
    currency: 'Currency',
    employee: 'Employee',
    employees: 'Employees',
    user: 'User',
    year: 'Year',
    month: 'Month',
    monthShort: 'month',
    monthShort2: 'months',
    monthShort6: 'months',
    above: 'above',
    status: 'Status',
    lp: 'No.',
    name: 'Name',
    shortname: 'Abbreviation',
    description: 'Description',
    sysNumber: 'Sys. No.',
    sysNumberLowerCase: 'sys. no.',
    oneToolId: 'OneTool ID',
    history: 'History',
    lastModification: 'Last modification',
    who: 'Who',
    when: 'When',
    noInformation: 'No information',
    creation: 'Creation',
    activeShe: 'Active',
    activeHe: 'Active',
    nonActiveHe: 'Inactive',
    nonActiveShe: 'Inactive',
    yes: 'Yes',
    no: 'No',
    yesUpperCase: 'YES',
    noUpperCase: 'NO',
    notDefined: 'ND',
    partly: 'Partly',
    sumUpperCase: 'SUM',
    sum: 'Sum',
    creator: 'Creator',
    creationDate: 'Creation date',
    emails: 'Email addresses',
    noData: 'No data',
    downloadDocs: 'Download documents',
    selectMonth: 'Select month',
    positionName: 'Position Name',
    country: 'Country',
    purchaser: 'Purchaser',
    brand: 'Brand',
    profilePosition: 'Profile position',
    type: 'Type',
    number: 'Number',
    startDate: 'Start date',
    endDate: 'End date',
    modificationDate: 'Modification date',
    title: 'Title',
    openNewWindow: 'Open in new window',
    addDate: 'Add date',
    pok: 'Platforma Obsługi Kampanii',
    help: 'Help',
    instructions: 'Instructions',
    openNewCard: 'Open in a new tab',
    invoiceType: 'Invoice type',
    issueDate: 'Issue date',
    saleDate: 'Sale date',
    exchangeRate: 'Exchange rate',
    sales: 'Sales',
    amount: 'Amount',
    sysError: 'System error',
    alertNotifyAdmin:
      'If the issue persists, please notify the System Administrator.',
    contractor: 'Contractor',
    recipient: 'Recipient',
    responsiblePerson: 'Responsible person',
    unwrittenData: 'Attention: data not saved',
    contract: 'Contract',
    publisher: 'Publisher',
    contractTv: 'Contract TV',
    itemsSelected: '{{number}} items',
    rangeMonth: 'Month range',
    positionPhase: 'Phase',
    deliveryTeam: 'Delivery team',
    newStartDate: 'New start date',
    newEndDate: 'New end date',
    oldStartDate: 'Old start date',
    oldEndDate: 'Old end date',
    errors: 'Errors',
    sendDate: 'Send date',
    bulkUpdate: 'Bulk update',
    bulkUpdateTooltip: 'Choose items for bulk editing',
    countryMarket: 'Country/market',
    noPositions: 'No positions.',
    askImportSelected:
      'Are you sure you want to import the selected positions?',
    importSelected: 'Import selected',
    noPositionsSelected: 'No positions selected for import.',
    positionType: 'Position type',
    nip: 'VAT ID',
    info: 'Information',
    alert: 'Alert',
    nameEn: 'Name in English',
    phases: 'Phases',
    communicationChannel: 'Communication channel',
  },
  component: {
    pointOut: 'Point out...',
    enter: 'Enter...',
    quickSearch: 'Quick search',
    searchInProgress: 'Searching...',
    numberOfRows: 'Number of rows',
    exportToExcel: 'Export to Excel',
    exportFileName: 'export',
    activeAutomatic: 'Active (automatic)',
    cleanFilter: 'Clear filter',
    noValues: 'No values',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    selected: 'Selected',
    noCurrency: 'No currency set in the company!',
    pleaseWait: 'Please wait...',
  },
  button: {
    clean: 'Clear',
    export: 'Export',
    close: 'Close',
    save: 'Save',
    delete: 'Delete',
    add: 'Add',
    edit: 'Edit',
    addDots: 'Add...',
    open: 'Open',
    cancel: 'Cancel',
    find: 'Find',
    download: 'Download',
    view: 'View',
    change: 'Change',
    restore: 'Restore data',
    refresh: 'Refresh',
    update: 'Update',
    select: 'Select',
    send: 'Send',
    back: 'Back',
    insert: 'Insert',
    next: 'Next',
    moveUp: 'Move up',
    moveDown: 'Move down',
    deleteConfirm: 'Are you sure you want to delete?',
  },
  attachment: {
    automatic: 'Automatic note',
    attachments: 'Attachments',
    attachment: 'Attachment',
    attachmentNew: 'New attachment / note',
    calculatorCurrency: 'Currency calculator',
    note: 'Note',
    noteNew: 'New note',
    type: 'Type',
    title: 'Title',
    file: 'File',
    invoicing: 'Invoicing',
    positionsSum: 'Related positions - purchase sum',
    relatedItems: 'Related items',
    addNote: 'Please provide a note.',
    askDeleteNote: 'Are you sure you want to delete the note?',
    askDeleteAttachment: 'Are you sure you want to delete the attachment?',
    noteAdded: 'Note added {{date}}',
    attachmentAdded: 'Attachment added {{date}}',
    chooseFile: 'Choose file',
    deleteAttachment: 'Delete attachment',
    deleteNote: 'Delete note',
    noFileSelected: 'No file selected',
    relatedTo: 'Related to',
    noNotes: 'No notes',
    noAttachments: 'No attachments',
    warningAnotherUserNote:
      'Another user may have added their own note. Close the window and reopen the note.',
    newNote: 'New note {{text}}',
    editNote: 'Edit note {{text}}',
    comment: 'Comment',
    downloadError: 'Error downloading attachments.',
    FVZLacks: 'Purchase invoice (FVZ) lacks in items',
    withoutTv: 'Profiles except TV',
    withTv: 'TV',
    sendRemindersWithoutTv: 'Send reminders (excluding TV)',
    sendRemindersTv: 'Send reminders (TV)',
    sendMail: 'Send e-mail',
    fileToLoad: 'File to load',
    finance: 'finance',
    mediaplanner: 'media planner',
    transparentBackgroundRequired:
      'The image should be in PNG format and have a transparent background. If you do not see a checkerboard under the image, select another file.',
    encryptedPDF:
      'Attention! The PDF document is partially encrypted and cannot be signed. To remove it, open the document in a PDF viewer (e.g. Adobe Acrobat, Chrome) and print it as a new PDF file, saving the resulting document. Then upload a new unencrypted PDF attachment to contract.',
    estimateItemPurchaseDeficienciesFileName: 'PurchaseDeficiencies',
    fileSizeExceededWithSize:
      'The total file size exceeds the allowed limit of {{maxSize}}.',
    fileSizeExceeded: 'The allowed file size has been exceeded.',
    dragAndDropFiles: 'Drop files here...',
    clickToSelectFiles: 'Drag and drop files or click to select',
    supportedFormats: 'Supported formats',
    files: 'Files',
  },
  email: {
    send: 'Send',
    create: 'Create email',
    recipients: 'Recipients',
    sendToTeam: 'Send email to team address',
    message: 'Message',
    sendDate: 'Send date',
    sentFrom: 'Sent from',
    sentTo: 'Sent to',
    subject: 'Subject',
    info: 'Info',
    resendToAnotherAddress: 'Resend to another address',
    resendEmail: 'Resend email',
    emailWillBeResentToSpecifiedAddresses:
      'The email will be resent only to the specified addresses below.',
    recipientEmailAddresses: 'Recipient email addresses',
    resendEmailQuestion: 'Are you sure you want to resend the email?',
    resendNotAvailableBeforeDate:
      'Resending is only available for emails sent on or after {{date}}.',
    preview: 'Email preview',
    emails: 'Emails',
    showOnlyNotSent: 'Show only unsent emails',
    type: 'Type',
    ccEmailAddresses: 'CC email addresses',
    bccEmailAddresses: 'BCC email addresses',
    sendingInProgress: 'Sending email in progress...',
    history: 'Send history',
    historyTooltip: 'Show resend history',
    original: 'Original',
    currentEmail: 'Current message',
    noHistory: 'No resend history for this message.',
    cc: 'CC',
    bcc: 'BCC',
    noData: 'No sent emails',
  },
  memo: {
    loading: 'Loading notes...',
    createNewMessage: 'Create a new message to the specified user',
    content: 'Content',
    giveContent: 'Enter content',
    purchaseInvoice: 'Purchase invoice no. sys.',
    saleInvoice: 'Sales invoice no. sys.',
    specialInvoicing: 'Special invoicing no. sys.',
    memosNumber: 'Number of notes',
    noMemos: 'No notes',
    information:
      'Notes related to {{subject}} will be visible in the notes window and to all company employees. Only commenting users will receive notifications when a new message is recorded.',
    contentPlhdr: 'Content...',
    noEmptyMessage: 'Message content cannot be empty',
    all: 'All',
    private: 'Private',
    documents: 'Documents',
    threadsCount: 'Total number of threads: ',
    newMessageThreadsCount: 'Number of threads with new messages: ',
    noMessageInSystem:
      'There are currently no messages in the system to display here',
    newMessage: 'New message',
    turnOff: 'Turn off',
    turnOn: 'Turn on',
    newMessageSound: 'incoming message sound',
    to: 'To',
  },
  concurrent: {
    editionMode: 'is in edit mode.',
    makingChanges: 'is currently making changes to the data',
    thisFVS: 'this sales invoice',
    thisFVZ: 'this purchase invoice',
    thisNotStandardInvoices: 'this special invoicing',
  },
  pdfViewer: {
    previousPage: 'Previous page',
    nextPage: 'Next page',
    page: 'Page',
    of: 'of',
    noTextCopy: 'PDF scan!',
    loading: 'Loading...',
    noPdfFile: 'No PDF file',
    error: 'Error loading file',
    confirmSignaturePointer: 'Confirm signature place',
    showSignaturePointer: 'Show signature place',
    changeSignaturePointer: 'Change signature place',
    selectSignaturePlace: 'Select a place to sign on the document',
    pan: 'Pan',
    select: 'Select',
    signatureLock: 'Signature lock',
  },
  download: {
    downloadDoc: 'Bulk download of documents',
    newDownloadDoc: 'New',
    downloadedDoc: 'Downloaded documents',
    downloadedMyDoc: 'My downloaded documents',
    creationTs: 'Creation date',
    budgetName: 'Budget',
    teamName: 'Team',
    clientName: 'Client',
    companyShortname: 'Company',
    salesInvoices: 'Sales invoices',
    salesInvoicesCopies: 'Sales invoices (copies)',
    purchaseInvoices: 'Purchase invoices',
    contracts: 'Contracts',
    attachments: 'Attachments',
    filterName: 'Filter',
    attachmentsTypes: 'Attachment types',
    rangeMonths: 'Month range',
    info: 'Information',
    waitingDataDownload:
      'Saving parameters for the package to be generated is in progress...',
    bulkDownloadsDocuments: 'Define parameters for needed documents',
    downloadInfo: `Select the parameters for the required documents.
    After clicking the "Export" button, the process of creating a package with documents will begin.
    The package will be available on the Downloaded documents tab after generation.`,
    downloadMyInfo: `Select the parameters for the required documents.
    After clicking the "Export" button, the process of creating a package with documents will begin.
    The package will be available on the My downloaded documents tab after generation.`,
    needAtLeastOneFilter: 'You must select a team, budget, client or campaign.',
    needSomeTypeDocuments:
      'You must select at least one type of document to download.',
    rangeMustBeInSameYear: 'Date range must be within the same year.',
    rangeMustBeDefined: 'Month range must be defined.',
    statusWaiting: 'Waiting for calculation',
    statusReady: 'Ready for download',
    statusCalculating: 'Calculating',
    statusFinished: 'Finished',
    notFoundFiles: 'No data found for download.',
    fileNameDownload: 'A package of documents for download',
    noData: 'No data to display',
  },
  invoice: {
    paid: 'Paid',
    withCorrections: 'Including corrections',
    withCorrectionsToOriginal: 'Is corrected by',
    otherCorrections: 'Other corrections',
  },
} as const;
